import React from 'react';

import Select from './Select';

/*
Example...
<BooleanSelect
    label="boolean_example"
    value={form.boolean_example}
    id="boolean_example"
    error={getFieldError('boolean_example')}
    onChange={(v) => handleInput('boolean_example', v)}
    isNullable={false}
/>
*/

/**
 * @function BooleanSelect
 *
 * See Select for params.
 *
 * @constructor
 */
const BooleanSelect = ({
    onChange,
    value,
    isNullable = false,
    labelYes = 'Yes',
    labelNo = 'No',
    ...rest
}) => {
    const yesNoOptions = [
        {
            label: labelYes,
            value: 'Yes'
        },
        {
            label: labelNo,
            value: 'No'
        }
    ];

    const yesNoNullOptions = [
        {
            label:  labelYes,
            value: 'Yes'
        },
        {
            label: labelNo,
            value: 'No'
        },
        {
            label: 'No response',
            value: null
        }
    ];

    return (
        <Select
            value={value === true ? 'Yes' : (value === false ? 'No' : null)}
            onChange={(v) => v === 'Yes' ? onChange(true) : (v === 'No' ? onChange(false) : onChange(null))}
            options={isNullable ? yesNoNullOptions : yesNoOptions}
            {...rest}
        />
    )
};

export default BooleanSelect;
